import React, { useContext } from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { RootState, SidebarItem } from 'types/types';
import { useDispatch, useSelector } from 'react-redux';
import { generateQueryParams } from 'utils/Utils';
import { removeDashboard } from 'features/dashboardsState';
import { NiKendoContext } from 'context/NiKendoContext';
import { removeDashboardFilters } from 'features/filtersState';
import { resetMapState } from 'features/advancedMapState';
import useView from 'hooks/useView';

type OpenedViewsProps = {
  openedViewsRef: React.RefObject<HTMLDivElement>;
};

export default function OpenedViews({ openedViewsRef }: OpenedViewsProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { niKendoModule }: any = useContext(NiKendoContext);
  const { openedViews } = useSelector(
    (state: RootState) => state.applicationState
  );
  const { closeOpenView } = useView();

  const handleViewClick = (selectedItem: SidebarItem) => {
    if (
      selectedItem.type === 'VIEW' ||
      selectedItem.type === 'DYNAMICVIEW' ||
      selectedItem.type === 'DASHBOARD'
    ) {
      navigate(
        `/${selectedItem.type.toLowerCase()}/${selectedItem.value.toLowerCase()}?${generateQueryParams(
          selectedItem.properties
        )}`
      );
    }
  };

  const handleCloseIconClick = (view: any) => {
    // Handle the updated array of opened views here
    if (view.type?.toLowerCase() == 'dashboard') {
      dispatch(resetMapState());
      dispatch(removeDashboard(view.value));
      dispatch(removeDashboardFilters(view.value));
      closeOpenView(view);
    } else {
      try {
        niKendoModule.application.layout.closeViewById(
          view.value,
          view.properties
        ); 
      } catch (error) {
        console.error('error closing view %o %o', view, error);
        navigate(`/view/landingPageView`);
      }
    }
  };


  return (
    <div className="opened-views" ref={openedViewsRef}>
      <List className="list">
        {openedViews.map((view) => (
          <ListItem
            key={view.value}
            button
            className={`item ${location.pathname.includes(view.value) ? 'active' : ''}`}
          >
            <ListItemText
              primary={view.text}
              className="text"
              onClick={!location.pathname.includes(view.value) ? () => handleViewClick(view) : undefined}
            />
            <CloseIcon
              className="close-icon"
              onClick={() => handleCloseIconClick(view)}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
}
